<template>
  <section class="section pt-5">
    <products-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import ProductsDatatable from "./products_datatable/Index.vue";
import { get_configuration } from "@/utils";

export default {
  name: "ProductIndex",
  components: { ProductsDatatable },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {
    this.retrieve_settings();
  },
};
</script>

<style scoped></style>
